import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as dayjs from "dayjs";
import * as FileSaver from "file-saver";
import { NgxSpinnerService } from "ngx-spinner";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { ListColumn } from "src/app/models/list-columns.model";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { LayoutsService } from "src/app/services/layouts.service";
import { MyErrorStateMatcher } from "src/app/utils/requireMatch";
import { HistorialUnidadService } from "./historial.service";
import { HistorialUnidadTableComponent } from "./special-table/special-table.component";

@Component({
  selector: "app-historial",
  templateUrl: "./historial.component.html",
  styles: [],
})
export class HistorialUnidadComponent implements OnInit {
  public form: FormGroup;
  public actions: any[] = [
    {
      desc: "Descargar",
      action: "down",
      visible: () => true,
      icon: "fas fa-file-download",
      color: "text-green-600",
    },
  ];

  public columns: ListColumn[] = [
    {
      name: "select",
      property: "select",
      visible: true,
      isModelProperty: false,
    },
    {
      name: "Fecha",
      property: "FechaDisplay",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Folio",
      property: "Folio",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Tipo",
      property: "TipoIcon",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];
  @ViewChild(HistorialUnidadTableComponent, { static: true })
  public tableComp: HistorialUnidadTableComponent;
  filtro: string = "";
  realdata: any[] = [];

  filteredUnidadesOptions: Observable<any[]>;
  matcherUnidades = new MyErrorStateMatcher();
  listUnidades: any[] = [];
  constructor(
    private fb: FormBuilder,
    public service: HistorialUnidadService,
    public layoutServ: LayoutsService,
    public spinner: NgxSpinnerService,
    public alerts: AlertasSwalService
  ) {
    this.layoutServ.changeHeader("Asignacion de unidades");
  }

  ngOnInit(): void {
    this.loadRecords();
    this.buildForm();
  }

  loadRecords() {
    this.service.getUnidades().subscribe(
      (resultData) => {
        this.listUnidades = resultData;
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  actionstable(e: { action: string; row: any }) {
    if (e.row.Tipo == "acta") this.downLoadActas(e.row.Id, e.row.Folio);
    else if (e.row.Tipo == "recepcion") this.downLoadRev(e.row.Id, e.row.Folio);
    else if (e.row.Tipo == "entrega") this.downLoadRev(e.row.Id, e.row.Folio);
    else if (e.row.Tipo == "mantenimiento")
      this.downLoadMT(e.row.Id, e.row.Folio);
  }
  downLoadActas(e, folio) {
    this.spinner.show();
    this.service.getPdfActas(e).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        this.downLoadFile(
          response.body,
          contentType,
          "acta_administrativa_" + folio + ".pdf"
        );
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      }
    );
  }
  downLoadRev(e, folio) {
    this.spinner.show();
    this.service.getPdfRevision(e).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        this.downLoadFile(
          response.body,
          contentType,
          "rececepcion_" + folio + ".pdf"
        );
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      }
    );
  }
  downLoadMT(e, folio) {
    this.spinner.show();
    this.service.getPdfMT(e).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        this.downLoadFile(
          response.body,
          contentType,
          "mantenimiento_" + folio + ".pdf"
        );
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      }
    );
  }
  downLoadFile(data: any, contentType: string, filename: string) {
    let blob = new Blob([data], { type: contentType });
    FileSaver.saveAs(blob, filename);
    this.spinner.hide();
  }
  private buildForm() {
    this.form = this.fb.group({
      Unidad: ["", [Validators.required]],
      r: [true],
      e: [true],
      m: [true],
      a: [true],
    });

    this.filteredUnidadesOptions = this.form.controls[
      "Unidad"
    ].valueChanges.pipe(
      startWith(""),
      map((value) => this._filterUnidades(value))
    );
  }
  displayWith(item?: any): string | undefined {
    return item ? item.Desc : undefined;
  }
  private _filterUnidades(value: any): string[] {
    let filterValue;
    if (typeof value === "string") filterValue = value.toLowerCase();
    else filterValue = value.Desc.toLowerCase();

    return this.listUnidades.filter((option) =>
      option.Desc.toLowerCase().includes(filterValue)
    );
  }
  reloadCheck() {
    this.searchHistorial(null);
  }
  public searchHistorial(event) {
    var form = this.form.value;
    if (form.Unidad.Id == null || form.Unidad.Id == undefined) {
      this.alerts.error("Unidad requerida", "Selecione una unidad");
      return;
    }

    this.service
      .getHistorial(form.Unidad.Id, form.a, form.e, form.m, form.r)
      .subscribe(
        (resultData) => {
          this.realdata = resultData.map((m) => {
            var TipoIcon =
              m.Tipo != "recepcion"
                ? m.Tipo != "entrega"
                  ? m.Tipo != "mantenimiento"
                    ? "📝"
                    : "🛠️"
                  : "⬅️"
                : "➡️";
            var FechaDisplay = m.Fecha
              ? dayjs(m.Fecha).format("DD/MM/YYYY hh:mm a")
              : "";
            return {
              Id: m.Id,
              Folio: m.Folio,
              TipoIcon: TipoIcon + " " + m.Tipo.toLocaleUpperCase(),
              FechaDisplay,
              Tipo: m.Tipo,
            };
          });

          this.tableComp.setData(this.realdata);
        },
        (err) => {
          this.alerts.error("error", err.error.Message);
        }
      );
  }
  getZip() {
    var form = this.form.value;
    var list = this.tableComp.getSelectedDown();
    if (list == null) return;
    if (list.length == 0) return;

   var tozip = list.map((m) => {
      return { Tipo: m.Tipo, Id: m.Id };
    })

    this.spinner.show();
    this.service.downZip(tozip).subscribe(
      (response) => {
        const contentType = response.headers.get("content-type");
        this.downLoadFile(response.body, contentType, (form?.Unidad?.Desc ?? 'XX') + '_D' + dayjs().format('YYYYMMDD')+ '_T' + dayjs().format('HHmm') + ".zip");
      },
      (err) => {
        this.spinner.hide();
        this.alerts.error("Error", "Ocurrio un error");
      }
    );
  }
  public get labelDown(): string {
    return this.tableComp?.getLabelDown() ?? "";
  }
}
